import { useCallback, useState } from 'react';
import { useLazyGetCompaniesPreviewQuery } from 'services/companies';

export const useClaimCompany = (activeNetwork) => {
  const [getCompanies] = useLazyGetCompaniesPreviewQuery({
    skip: !activeNetwork?.id,
  });
  const [company, setCompany] = useState(null);

  const handleSearch = useCallback(
    async (keyword) => {
      try {
        const { data } = await getCompanies({
          keyword,
          networkId: activeNetwork.id,
          exclude_organizations_without_domain: true,
          page: 1,
          perPage: 40,
        });

        return (
          data?.items?.map(({ slug, name, logoUrl }) => ({
            label: name,
            value: slug,
            avatarUrl: logoUrl,
          })) ?? []
        );
      } catch (error) {
        return [];
      }
    },
    [activeNetwork?.id, getCompanies],
  );

  return { handleSearch, company, setCompany };
};
